import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/process/step"

const serviceName = "ProcessStep-Service: ";

export default class ProcessStepService {
  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static postToAPI(processStep, successF, errorF) {
    WrapperService.post(API_URL, processStep, serviceName, successF, errorF);
  }

  static putToAPI(processStep, successF, errorF) {
    WrapperService.put(API_URL + "/" + processStep.id, processStep, serviceName, successF, errorF);
  }

  static deleteFromAPI(processStep, successF, errorF) {
    WrapperService.delete(API_URL + "/" + processStep.id, serviceName, successF, errorF);
  }
}
